import api from './axios';

export const getCampaignsApi = (params = {}) => api.get('/admin/campaigns', { params });
export const getCampaignApi = (id) => api.get(`/admin/campaigns/${id}`);
export const createCampaignApi = (data) => api.post('/admin/campaigns', data);
export const updateCampaignApi = (id, data) => api.put(`/admin/campaigns/${id}`, data);
export const scheduleCampaignApi = (id, data) => api.post(`/admin/campaigns/${id}/schedule`, data);
export const sendCampaignApi = (id) => api.post(`/admin/campaigns/${id}/send`, {});
export const cancelCampaignApi = (id) => api.post(`/admin/campaigns/${id}/cancel`, {});
export const duplicateCampaignApi = (id) => api.post(`/admin/campaigns/${id}/duplicate`, {});
export const retryCampaignApi = (id) => api.post(`/admin/campaigns/${id}/retry`, {});
export const getCampaignAnalyticsApi = (id) => api.get(`/admin/campaigns/${id}/analytics`);
